<template>
  <TabMenu :model="tabs" v-if="tabs"/>
</template>

<script>
export default {
  name: "AncestrylineTab",
  props:{
    tabs: {type: Array, default: null}
  }
}
</script>

<style scoped>

</style>